import React, { useState } from 'react';
import PropTypes from 'prop-types';

// DS
import {
  Col,
  Row,
  VertTypography,
  VertButton,
  VertCheckbox,
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/services/SummaryStyles.less';
import { pointsMask } from 'Utils/commons/points';
import { useSelector } from 'react-redux';
import { currencyMask } from 'Utils/commons/mask';

// CHECKOUT SUMMARY COMPONENT
const PhoneRechargeSummary = ({ ...props }) => {
  const Catalog = useSelector(({ Catalog: data }) => data);
  const { isLoadingFuelCredit } = useSelector(({ FuelCredit: data }) => data);

  const {
    pointsQuantity,
    milesQuantity,
    isValid,
    finish,
    acceptTerms,
    termsChange,
    openTerms,
  } = props;

  const {
    currencyConfiguration: { decimalPlaces, pointsName },
  } = Catalog;
  const pointsFormated = pointsMask(pointsQuantity, decimalPlaces, pointsName);

  return (
    <Col className="service-summary-wrapper col-12 col-md-auto">
      <Col className="service-summary-content">
        <Row>
          <VertTypography.Title level={3}>
            Resumo do resgate
          </VertTypography.Title>
        </Row>
        <Row className="row-description">
          <VertTypography.Paragraph>Tipo de crédito:</VertTypography.Paragraph>
          <VertTypography.Paragraph>Shell Box</VertTypography.Paragraph>
        </Row>
        <Row className="row-description">
          <VertTypography.Paragraph>
            Crédito combustível de:
          </VertTypography.Paragraph>
          <VertTypography.Paragraph>
            {currencyMask(milesQuantity)}
          </VertTypography.Paragraph>
        </Row>
        <div className="divider" />
        <Row className="row-description">
          <VertTypography.Paragraph>Pontos Utilzados:</VertTypography.Paragraph>
          <VertTypography.Paragraph strong>
            {`${pointsFormated?.value} ${pointsFormated?.label}`}
          </VertTypography.Paragraph>
        </Row>
        <Row>
          <VertTypography.Paragraph strong>
            Importante:
            <VertTypography.Paragraph>
              O crédito combustível será transferido em até 10 dias úteis. Caso
              não seja creditado nesse prazo, entre em contato conosco.
            </VertTypography.Paragraph>
          </VertTypography.Paragraph>
        </Row>
        <Row className="row-termsOfUse">
          <VertCheckbox
            checked={acceptTerms}
            value={!acceptTerms}
            defaultChecked={false}
            onChange={({ target }) => termsChange(target.checked)}
          />
          <VertTypography.Paragraph>
            Li e aceito o <a onClick={openTerms}>Termo de uso.</a>
          </VertTypography.Paragraph>
        </Row>
        <Row className="service-summary-button">
            <VertButton
              className={`${!isValid && 'disabled-button'}`}
              onClick={() => finish()}
              type="highlight"
              disabled={!isValid}
              loading={isLoadingFuelCredit}
            >
              Finalizar resgate
            </VertButton>
        </Row>
      </Col>
    </Col>
  );
};

PhoneRechargeSummary.propTypes = {
  pointsQuantity: PropTypes.number,
  milesQuantity: PropTypes.number,
  isValid: PropTypes.bool,
  acceptTerms: PropTypes.bool,
  finish: PropTypes.func,
  termsChange: PropTypes.func,
};

export default PhoneRechargeSummary;
